import {AfterViewInit, Component, Injector} from '@angular/core';
import {BaseAdminPanelComponent} from "../admin-panel/base-admin-panel/base-admin-panel.component";
declare const $;

@Component({
    selector: 'app-data',
    templateUrl: './data.component.html',
    styleUrls: ['./data.component.css'],
    standalone: false
})
export class DataReportComponent implements AfterViewInit
{
  ngAfterViewInit()
  {
    window.dispatchEvent(new CustomEvent("ComponentLoad", { detail: "Data" }));
  }
  public openTabTrackingRight(tabName: string, headNum: number) {
    var x = $(".rightreport .tabpage");
    for (var i = 0; i < x.length; i++)
      $(x[i]).addClass("hidden");

    $("#" + tabName).removeClass("hidden");

    x = $(".righttrack .btn_tabs button");
    for (var i = 0; i < x.length; i++)
      $(x[i]).removeClass("active");
    $(x[headNum - 1]).addClass("active");

    //$(window).trigger('resize');
  }

}
